module.exports = __webpack_public_path__ + "img/page8.c806ba68.jpg";